<template>
  <div class="cheating-manage-page">
    <van-nav-bar title="体育测试违规作弊管理" fixed placeholder />

    <van-tabs v-model="activeTab" color="#1989fa" sticky offset-top="46px">
      
      <van-tab title="违规作弊记录">
        <div class="toolbar">
          <van-dropdown-menu active-color="#1989fa" class="filter-menu">
            <van-dropdown-item v-model="filterStatus" :options="statusOptions" @change="handleFilter" />
            <van-dropdown-item v-model="filterType" :options="typeOptions" @change="handleFilter" />
          </van-dropdown-menu>
          <!-- <div class="action-btn-box">
            <van-button type="danger" icon="plus" size="small" block round @click="simulateAddViolation">
              模拟捕获新违规
            </van-button>
          </div> -->
        </div>

        <div class="record-list" v-if="filteredRecords.length > 0">
          <div class="record-card" v-for="item in filteredRecords" :key="item.id">
            <div class="card-header">
              <span class="student-info">
                <strong class="name">{{ item.studentName }}</strong>
                <span class="class-name">{{ item.className }}</span>
              </span>
              <van-tag :type="item.status === 1 ? 'success' : 'danger'" size="medium">
                {{ item.status === 1 ? '已处理' : '待处理' }}
              </van-tag>
            </div>

            <div class="card-body">
              <div class="info-row">
                <span class="label">违规时间：</span>
                <span class="val">{{ item.time }}</span>
              </div>
              <div class="info-row">
                <span class="label">测试项目：</span>
                <span class="val">{{ item.project }}</span>
              </div>
              <div class="info-row">
                <span class="label">违规类型：</span>
                <span class="val text-danger">{{ item.violationType }}</span>
              </div>
              <div class="info-row font-sm" v-if="item.evidence">
                <span class="label">违规证据：</span>
                <span class="val text-grey">{{ item.evidence }}</span>
              </div>
              <div class="info-row font-sm" v-if="item.result">
                <span class="label">处理结果：</span>
                <span class="val text-primary">{{ item.result }}</span>
              </div>
            </div>

            <div class="card-footer">
              <van-button 
                v-if="item.status === 0" 
                type="info" 
                size="mini" 
                plain 
                round
                @click="executeProcess(item.id)"
              >
                执行裁决
              </van-button>
              <van-button 
                type="default" 
                size="mini" 
                plain 
                round 
                class="margin-left-xs"
                @click="deleteRecord(item.id)"
              >
                误报撤销
              </van-button>
            </div>
          </div>
        </div>
        <van-empty v-else description="暂无符合条件的违规作弊记录" />
      </van-tab>

      <van-tab title="作弊处理规则">
        <div class="rules-container">
          <div class="rules-notice">
            <van-icon name="warning-o" color="#ed6a0c" size="18" />
            <span class="notice-text">国家体育测试严禁任何形式的作弊行为，一经AI终端、手环、或人工考官核实，将严格依照以下规则裁决。</span>
          </div>

          <van-collapse v-model="activeCollapseNames">
            <van-collapse-item 
              v-for="rule in ruleList" 
              :key="rule.id" 
              :title="rule.title" 
              :name="rule.id"
              :value="rule.level"
            >
              <div class="rule-detail-box">
                <div class="detail-section">
                  <span class="section-lbl">【行为定义】</span>
                  <p class="section-val">{{ rule.definition }}</p>
                </div>
                <div class="detail-section margin-top-sm">
                  <span class="section-lbl text-danger">【处理办法】</span>
                  <p class="section-val text-danger font-bold">{{ rule.punishment }}</p>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </van-tab>

    </van-tabs>
  </div>
</template>

<script>
export default {
  name: 'CheatingManagement',
  data() {
    return {
      activeTab: 0,
      activeCollapseNames: ['1', '2'], // 默认展开前两项规则

      // 筛选机制绑定变量
      filterStatus: -1, // -1全部, 0待处理, 1已处理
      filterType: 'ALL',

      // 下拉菜单的可选项配置
      statusOptions: [
        { text: '全部处理状态', value: -1 },
        { text: '待处理违规', value: 0 },
        { text: '已处理违规', value: 1 },
      ],
      typeOptions: [
        { text: '全部违规类型', value: 'ALL' },
        { text: '冒名顶替/替考', value: '替考' },
        { text: '恶意篡改设备/手环', value: '设备篡改' },
        { text: '遮挡AI终端摄像头', value: '遮挡摄像头' },
        { text: '携带多份手环/传感器', value: '多带手环' },
      ],

      // 【自动填充数据源 1】：作弊违规记录库
      records: [
        // { id: 1, studentName: '张明', className: '初一(3)班', time: '2026-06-10 10:15', project: '1000米跑', violationType: '多带手环', evidence: 'AI红外传感器捕捉到单人携带3枚蓝牙运动手环', status: 1, result: '取消本次及全年体育测验成绩，记入个人诚信档案' },
        { id: 2, studentName: '李华', className: '初二(1)班', time: '2026-04-11 14:30', project: '立定跳远', violationType: '替考', evidence: 'AI室内运动角人脸识别与原学生底册库不匹配', status: 0, result: '' },
        // { id: 3, studentName: '王小龙', className: '初三(2)班', time: '2026-06-12 09:04', project: '仰卧起坐', violationType: '遮挡摄像头', evidence: '室内智能体测终端摄像头被校服外套遮挡超过15秒', status: 0, result: '' },
        // { id: 4, studentName: '赵铁柱', className: '初一(5)班', time: '2026-06-12 11:20', project: '肺活量测试', violationType: '设备篡改', evidence: '吹气嘴插口处被加装外部气流分流阻尼器', status: 1, result: '该单项体测数据作废，成绩记0分，通报批评' }
      ],
      
      // 存储经过筛选后的展示数组
      filteredRecords: [],

      // 【自动填充数据源 2】：官方作弊处理规则
      ruleList: [
        { id: '1', title: '冒名顶替/替考行为', level: '极重度违规', definition: '由他人代替参加体育测试、或者代替他人参加任何涉及分数、等级认定的体育终端设备打卡行为。', punishment: '取消本次及全学年体育测试资格及全部科目成绩，成绩直接记0分，并记入学生诚信档案。' },
        { id: '2', title: '恶意携带多枚手环/传感器', level: '重度违规', definition: '单人在测试、长跑、日常打卡过程中，身上或口袋内携带多枚他人运动手环、智能传感器进行欺诈刷量。', punishment: '当事所有人相关科目的打卡及测试成绩全部作废记0分，扣除本周期日常锻炼学分。' },
        { id: '3', title: '蓄意遮挡AI终端摄像头', level: '中度违规', definition: '在AI室内运动角、AI体测一体机测试中，故意用衣物、纸张或身体死角长时间遮挡摄像头导致无法进行骨骼点判定。', punishment: '初犯给予系统弹窗警告并暂停计数，累计满2次或拒绝改正者，系统将自动取消该项目本次测试成绩。' },
        { id: '4', title: '恶意破坏或篡改体测设备', level: '极重度违规', definition: '对室内体测设备（如肺活量计、身高体重称、跳远测距垫）进行物理破坏，或通过非正规软硬件工具伪造底层蓝牙/网口包数据。', punishment: '视情节移交学校教务处进行记过处分，相关所有项目体育评分判定为不及格。' }
      ]
    };
  },
  created() {
    this.handleFilter(); // 页面初始化执行一次过滤填充
  },
  methods: {
    // 根据下拉菜单状态执行数据过滤
    handleFilter() {
      this.filteredRecords = this.records.filter(item => {
        const matchStatus = this.filterStatus === -1 ? true : item.status === this.filterStatus;
        const matchType = this.filterType === 'ALL' ? true : item.violationType === this.filterType;
        return matchStatus && matchType;
      });
    },

    // 核心功能：模拟捕获新违规 (实现数据新增和联动变化)
    simulateAddViolation() {
      const mockNames = ['周杰', '林华', '马小超', '刘芳'];
      const mockClasses = ['初一(1)班', '初二(4)班', '初三(6)班'];
      const mockProjects = ['50米跑', '引体向上', '引体向上', '坐位体前屈'];
      const mockTypes = ['替考', '遮挡摄像头', '多带手环'];
      const mockEvidences = ['动态视觉追踪识别出动作轨迹异常', '设备感知到重力传感器在非测试区高频刷新'];

      // 随机组合假数据
      const randomId = Date.now();
      const newViolation = {
        id: randomId,
        studentName: mockNames[Math.floor(Math.random() * mockNames.length)],
        className: mockClasses[Math.floor(Math.random() * mockClasses.length)],
        time: new Date().toLocaleString(),
        project: mockProjects[Math.floor(Math.random() * mockProjects.length)],
        violationType: mockTypes[Math.floor(Math.random() * mockTypes.length)],
        evidence: mockEvidences[Math.floor(Math.random() * mockEvidences.length)],
        status: 0, // 默认新来的是待处理
        result: ''
      };

      // 插入到原始数组头部
      this.records.unshift(newViolation);
      this.handleFilter(); // 刷新视图
      this.$toast.success(`系统智能捕获了 [${newViolation.studentName}] 的新违规！`);
    },

    // 核心功能：执行裁决 (实现数据更新状态变化)
    executeProcess(id) {
      this.$dialog.confirm({
        title: '违规裁决确认',
        message: '确认按照国家体测评分规则对该学生执行扣分/作废处理吗？'
      }).then(() => {
        const target = this.records.find(item => item.id === id);
        if (target) {
          target.status = 1;
          target.result = '已被系统强制判定：成绩作废并取消该科目重考资格';
          this.handleFilter(); // 刷新列表
          this.$toast.success('裁决生效，数据已锁定');
        }
      }).catch(() => {});
    },

    // 核心功能：误报撤销 (实现数据删除变化)
    deleteRecord(id) {
      this.$dialog.confirm({
        title: '撤销确认',
        message: '确认该条记录为误报并将其从系统中彻底移除吗？'
      }).then(() => {
        // 从核心数组过滤掉该数据
        this.records = this.records.filter(item => item.id !== id);
        this.handleFilter(); // 刷新显示
        this.$toast.success('记录撤销成功，数据已清空');
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.cheating-manage-page {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 24px;
}

/* 工具栏：包含筛选和添加按钮 */
.toolbar {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 12px;
  border-bottom: 1px solid #ebedf0;
}
.filter-menu {
  flex: 1;
}
.action-btn-box {
  width: 130px;
}

/* 违规列表卡片样式 */
.record-list {
  padding: 12px;
}
.record-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px dashed #ebedf0;
}
.student-info .name {
  font-size: 16px;
  color: #323233;
}
.student-info .class-name {
  font-size: 13px;
  color: #969799;
  margin-left: 8px;
}

.card-body {
  padding: 10px 0;
}
.info-row {
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 4px;
}
.info-row .label {
  color: #969799;
}
.info-row .val {
  color: #323233;
}

.card-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
  border-top: 1px solid #f2f3f5;
}

/* 规则库 Tab 的专属样式 */
.rules-container {
  padding: 12px;
}
.rules-notice {
  background-color: #fff7cc;
  padding: 10px 12px;
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.notice-text {
  font-size: 12px;
  color: #ed6a0c;
  margin-left: 6px;
  line-height: 1.4;
}
.rule-detail-box {
  font-size: 13px;
  line-height: 1.5;
}
.rule-detail-box .section-lbl {
  font-weight: bold;
  color: #646566;
}
.rule-detail-box .section-val {
  margin: 4px 0 0 0;
  color: #323233;
}

/* 全局工具辅助样式类 */
.text-danger { color: #ee0a24; }
.text-primary { color: #1989fa; }
.text-grey { color: #7d7e80; }
.font-bold { font-weight: bold; }
.font-sm { font-size: 12px; }
.margin-top-sm { margin-top: 8px; }
.margin-left-xs { margin-left: 6px; }
</style>